import { FC } from 'react'
import { Outlet, replace, useOutletContext } from 'react-router-dom'

// ROUTES
import { UpdateEmailRoute } from './update'
import { ViewEmailRoute } from './view'
import { VerifyEmailRoute } from './verify'

// TYPES
import type { EmailAddressResource } from '@clerk/types'
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'
import { useProfileEmailContext } from '..'


type EmailIdContext = ReturnType<typeof useProfileEmailContext> & { resource: EmailAddressResource }
export const useEmailIdContext = () => useOutletContext<EmailIdContext>()

const Component: FC<{}> = () => {
    const resource = useLoader<typeof loader>()
    const context = useProfileEmailContext()

    return <Outlet context={{ ...context, resource } satisfies EmailIdContext} />
}

const loader = createAuthenticatedLoader(async ({ params }, Clerk) => {
    const emailId = params['emailId'] || ''
    const resource = Clerk.user?.emailAddresses.find(({ id }) => id === emailId)

    if (!!resource) return resource
    else return replace('/account/profile')
})

const EmailIdRoute: RouteObject = {
    path: ":emailId",
    Component,
    loader,
    children: [
        UpdateEmailRoute,
        ViewEmailRoute,
        VerifyEmailRoute,
    ],
}

export { EmailIdRoute }
